module.exports = __webpack_public_path__ + "img/1x.4d7f416.jpg";